import { Breadcrumb } from '@e3dc-react/shell/Elements/Header/Breadcrumbs'
import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import useSetBreadcrumbsForPage from 'src/Libs/navigation/hooks/use-set-breadcrumbs-for-page'

/**
 * Hook to set the page title and breadcrumbs for a given page in the end-user-settings
 */
export const useSystemSettingsTitleAndBreadcrumbs = ({
  pageTitleKey,
  navigateBackSteps = 1,
  breadcrumb,
}: {
  pageTitleKey: string
  navigateBackSteps?: number
  breadcrumb?: Breadcrumb
}): void => {
  const navigate = useNavigate()

  const onBreadcrumbClick = useCallback((): void => {
    navigate(-navigateBackSteps)
  }, [navigate, navigateBackSteps])

  const parentBreadcrumb = useMemo(() => ({ title: 'framework.systemProperties', onClick: onBreadcrumbClick }), [onBreadcrumbClick])

  useSetBreadcrumbsForPage(breadcrumb || parentBreadcrumb, pageTitleKey)
}
